module.exports = __webpack_public_path__ + "static/fipcnavybear1-912877a65c6e73e536202089a7360842.jpeg";